/** 简体中文. See `en.ts` for what each key is and what it has to fit. */

import type { MessageKey } from "./en";

export const zh: Record<MessageKey, string> = {
  metaDescription:
    "免费的实时天气地图，浏览器内动画播放：GFS、ECMWF、AIFS 数值预报，雷达与卫星云图回放，台风路径，三维雷达与探空图。",
  pageTitleLive: "{variable}预报图 · {model} {hours}H",
  pageTitleLiveObservation: "{variable}观测图 · {model} · 近{hours}小时",
  mapAria: "全球气温与降水预报地图",
  modelSwitchAria: "数据集",
  variableSwitchAria: "气象变量",
  varTemp: "气温",
  varPrecip: "降水",
  varWind: "风场",
  varSolar: "辐射",
  varRadar: "雷达",
  varOrog: "地形",
  varInfrared: "红外 10.4",
  varShortwave: "短波 3.9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "彩色",
  varGust: "阵风",
  varCloud: "云量",
  varCape: "对流能",
  varPwat: "气柱",
  varPtype: "类型",
  varCin: "抑制",
  varHpbl: "高度",
  varVis: "能见度",
  varDewPoint: "露点",
  varFeelsLike: "体感",
  varOmega: "垂直速度",
  varThetaE: "假相当位温",
  varCat: "晴空湍流",
  varInflow: "暖湿流",
  varFront: "锋区",
  varHotspot: "热点",
  varFfwi: "火险气象",
  varFwalert: "干燥大风",
  varSst: "海表",
  varIce: "海冰",
  varWave: "海浪",
  varAod: "总量",
  varPm: "2.5",
  varDustsfc: "沙尘",
  varTsoil: "土温",
  varSoilw: "土湿",
  varHumidity: "湿度",
  varVapourFlux: "水汽",
  varPressure: "气压",
  varHeight: "位势",
  varPressureField: "气压场",
  varUnknownLayer: "数据层",

  glyphTmp2m: "温",
  glyphPrate: "水",
  glyphWind10m: "风",
  glyphDswrf: "辐",
  glyphCref: "雷",
  glyphIr104: "卫",
  glyphIr039: "短",
  glyphDustrgb: "尘",
  glyphDustcf: "信",
  glyphZhouye: "昼",
  glyphTruecolor: "彩",
  glyphGust: "阵",
  glyphTcdc: "云",
  glyphCape: "能",
  glyphVis: "视",
  glyphPwat: "柱",
  glyphCin: "抑",
  glyphHpbl: "层",
  glyphPtype: "型",
  glyphDpt2m: "露",
  glyphAptmp2m: "感",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "暖",
  glyphFront: "锋",
  glyphHotspot: "热",
  glyphFfwi: "险",
  glyphFwalert: "警",
  glyphTmpsfc: "海",
  glyphIce: "冰",
  glyphWave: "浪",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "沙",
  glyphTsoil: "地",
  glyphSoilw: "墒",
  glyphPressure: "压",
  glyphRh: "湿",
  glyphQflux: "汽",
  tipTemp: "气温",
  tipHumidity: "相对湿度",
  tipWind: "风",
  tipPressure: "气压与位势高度",
  tipVapourFlux: "水汽通量",
  tipCloud: "云量",
  tipOmega: "垂直速度",
  tipThetaE: "假相当位温",
  tipCat: "晴空湍流",
  tipIce: "海冰",
  tipWave: "海浪",
  tipAod: "气溶胶光学厚度",
  tipPm: "颗粒物",
  tipTsoil: "土壤温度",
  tipSoilw: "土壤湿度",
  tipSatellite: "卫星影像",
  levelSwitchAria: "层次",
  levelCaption: "层次",
  linesCaption: "等压线",
  accumCaption: "累计",
  accumRateGloss: "降水率",
  accumTotalGloss: "{window} 累计",
  modelHeading: "数据集",
  linesRemoveTitle: "再按一次关闭等压线叠加",
  fieldSectionAria: "填充场",
  overlaySectionAria: "叠加层",
  markSectionAria: "标记",
  tipMore: "本次运行的全部图层",
  varMore: "图层",
  glyphMore: "+",
  fieldSheetAria: "图层",
  fieldSheetHeading: "图层",
  fieldGroupTemperature: "温度",
  fieldGroupMoisture: "水分",
  fieldGroupSoil: "土壤",
  fieldGroupWind: "风",
  fieldGroupDynamics: "动力",
  fieldGroupRadiation: "辐射与能见度",
  fieldGroupAerosol: "气溶胶与空气质量",
  fieldGroupOcean: "海洋",
  fieldGroupHydrology: "河流与洪水",
  fieldGroupSatellite: "卫星",
  fieldGroupOther: "其他",
  fieldGroupImagery: "逐日影像：NASA GIBS",
  gibsTrueColor: "真彩",
  gibsFalseColor: "火情",
  gibsTipTrue: "真彩",
  gibsTipFire: "火情假彩：过火迹地暗红",
  varParticles: "粒子",
  glyphParticles: "粒",
  varVolume: "三维云",
  glyphVolume: "体",
  levelAlone: "只看线",
  levelAloneTitle: "只看等压线：去掉填充场，再按一次恢复",
  creditsTrigger: "数据来源",
  creditsHeading: "数据来源与致谢",
  creditsGfs: "预报数据：GFS 0.25° 与 sflux",
  creditsHrrr: "预报数据：HRRR 3 公里，美国本土",
  creditsGefsAero: "气溶胶预报：GEFS-Aerosols 0.25°，光学厚度与地面颗粒物",
  creditsCmaDust: "沙尘预报：CMA-CW v1.0/DUST（WMO SDS-WAS 亚洲中心）0.15°，亚洲区域，经 WMO WIS2",
  creditsSilam: "空气质量预报：FMI SILAM v6.1 全球 0.2°，CC BY 4.0",
  creditsCfs: "季节预报：CFSv2，9 个月，6 小时间隔",
  creditsEcmwf: "含经修改的 ECMWF 数据，CC BY 4.0",
  creditsIfsHres: "改编自 ECMWF IFS，由 ECMWF 提供，依 CC BY 4.0 授权；经 Open-Meteo 转发；IFS HRES 约 9 公里，重采样到 0.1°",
  creditsMrms: "雷达观测：MRMS，美国本土",
  creditsNexrad: "单站雷达：基本反射率与径向速度，美国",
  creditsJma: "雷达降水：气象厅临近预报，日本（重采样）",
  creditsHimawari: "卫星影像：向日葵 9 号 AHI，日本气象厅，经 NOAA 开放数据（重投影）",
  creditsGoes: "卫星影像：GOES-19 东、GOES-18 西 ABI，NOAA NESDIS，经 NOAA 开放数据（重投影）",
  creditsMeteosat: "卫星影像：含经修改的 EUMETSAT Meteosat 数据 {year}；Meteosat-12 FCI，整点扫描周期，CC-BY-4.0（重投影）",
  creditsSounding: "探空观测：GTS TEMP 报文经 WIS2 转发，各国气象部门",
  creditsAirport: "机场 METAR 与 TAF：各国气象部门经 NOAA/NWS 航空气象中心转发",
  creditsFirms: "活跃火点：LANCE FIRMS 近实时，VIIRS 375 m 与 MODIS，NASA ESDIS",
  creditsGibs: "逐日影像：MODIS 与 VIIRS 校正反射率，NASA ESDIS",
  creditsRadar: "雷达拼图",
  creditsBasemap: "底图：© OpenStreetMap 贡献者",
  creditsTerrain: "地形晕渲：© Mapterhorn，高程数据来源一览",
  creditsPeaks: "山峰名称与海拔：CC0",
  creditsCode: "源代码：ringsaturn/xue",
  caseTag: "个例",
  caseSummaryAria: "个案摘要",
  runCycle: "模式周期",
  recordSpan: "记录时段",
  latestObservation: "最新观测",
  latestNowcast: "最新临近预报",
  awaitingData: "等待数据",
  validTimeLabel: "当前有效时间",
  observationTimeLabel: "当前观测时间",
  statsAria: "详细统计信息",
  statsCloseAria: "关闭详细统计信息",
  bufferedFrames: "缓存帧",
  downloadedBytes: "数据量",
  formatLabel: "格式",
  formatZarr: "Zarr",
  preloadProgressAria: "预报数据预加载进度",
  statDataset: "数据集",
  statGrid: "网格",
  statFrameCache: "帧缓存",
  statDecodeTime: "解码耗时",
  statDecodeRate: "解码速率",
  statViewport: "视口采样",
  statConnection: "网络连接",
  awaitingManifest: "等待数据舱单",
  legendPrateAria: "降水强度色标",
  timelineAria: "预报时间控制",
  playAnimation: "播放动画",
  pauseAnimation: "暂停动画",
  playbackSpeed: "播放速度",
  exportOpenAria: "导出动画",
  exportSheetAria: "导出动画",
  exportHeading: "导出",
  exportFormat: "格式",
  exportSize: "尺寸",
  exportFps: "帧率",
  exportRange: "帧范围",
  exportFrom: "起",
  exportTo: "止",
  exportRun: "导出",
  exportCancel: "取消",
  exportSummary: "{size}，{frames} 帧，{seconds} 秒，约 {bytes}",
  exportCapturing: "正在截取 {done}/{total}",
  exportEncoding: "正在编码 {percent}%",
  exportFailed: "导出失败",
  readingManifest: "正在读取清单",
  forecastHourAria: "预报时次",
  forecastDaysAria: "逐日预报分段",
  observationDaysAria: "逐日分段",
  mapMenuAria: "地图选项",
  menuStats: "详细统计信息",
  menuCopyDebug: "复制调试信息",
  errorTitle: "数据无法显示",
  retry: "重新读取",
  langPickerAria: "语言",
  langPickerHeading: "语言",
  themeToggleAria: "切换浅色 / 深色",
  viewGlobeAria: "地球视图",
  viewTerrainAria: "三维地形",
  viewContoursAria: "地形等高线",
  viewResetNorthAria: "重置为正北",
  viewResetPitchAria: "重置俯仰",
  viewBoxAria: "风暴特写：框选一块区域",
  viewSectionAria: "垂直剖面：拖一条线",
  viewDistanceAria: "测距：依次点击各点，再点最后一点结束",
  viewAreaAria: "测面积：依次点击各顶点，再点首点或末点结束",
  particlesToggle: "粒子动画",
  particlesToggleAria: "切换风场粒子动画",

  dataInterrupted: "数据加载中断",
  errorHint: "{message}。请确认已运行 make mvp,并通过 make serve 打开页面。",
  loadFailed: "加载失败",
  webglLost: "WebGL 不可用：请完全退出浏览器后重新打开",
  saveData: "省流",
  debugCopied: "调试信息已复制",
  copyFailed: "复制失败",
  bundleResident: "数据包已驻留内存",
  viewportResident: "当前视野已缓冲完毕",
  streamingOnDemand: "按需流式加载中",
  receivingBundle: "正在接收预报数据包",
  receivingBundlePercent: "接收数据包 {percent}%",
  readingIndex: "正在读取数据索引",
  initializingDecoder: "正在初始化解码器",
  framesReady: "{count} 帧就绪",
  readingData: "正在读取数据",
  bundleLoadFailed: "预报数据包加载失败",
  workerStartFailed: "解码 Worker 启动失败",
  decodeFailed: "解码失败",
  frameDecodeFailed: "帧解码失败:{message}",
  legendAria: "{label}色标",
  legendInflow: "暖湿气流",
  legendFront: "锋区（θe 梯度）",
  legendHotspot: "火点热点（3.9 µm 上下文判定）",
  legendFfwi: "Fosberg 火险气象指数",
  legendFwalert: "相对湿度低于 30 % 且阵风 ≥ 10 m/s",
  legendDustDust: "沙尘",
  legendDustThickHigh: "厚高云",
  legendDustThinHigh: "薄高云",
  legendDustMid: "中云",
  legendDustLow: "低暖云",
  legendDustDesert: "炎热沙漠地表",
  legendDustSurface: "海面与植被地表",
  legendTruecolorCloud: "云与雪",
  legendTruecolorSea: "海面",
  legendTruecolorLand: "陆地与植被",
  legendTruecolorNightCloud: "夜间云（红外）",
  legendTruecolorNightGround: "夜间晴空",
  legendPtypeRain: "雨",
  legendPtypeFreezingRain: "冻雨",
  legendPtypeSnow: "雪",
  legendPtypeIcePellets: "冰粒",
  legendDisrpBelow: "低于 1.5 年一遇",
  legendDisrp1p5: "≥ 1.5 年一遇",
  legendDisrp2: "≥ 2 年一遇",
  legendDisrp5: "≥ 5 年一遇",
  legendDisrp20: "≥ 20 年一遇",
  legendCatLight: "轻度",
  legendCatModerate: "中度",
  legendCatModerateSevere: "中度–严重",
  legendCatSevere: "严重",
  varLabelTmp2m: "2 米气温",
  varLabelPrate: "降水强度",
  varLabelDswrf: "太阳辐射",
  varLabelWind10m: "10 米风",
  varLabelWind80m: "80 米风",
  varLabelWind100m: "100 米风",
  varLabelCref: "雷达组合反射率",
  varLabelRefl3d: "三维雷达回波",
  varLabelCloud3d: "三维云水",
  varLabelOrog: "地形高度",
  varLabelIr104: "红外影像（10.4 µm 亮温）",
  varLabelIr039: "短波红外（3.9 µm 亮温）",
  varLabelDustrgb: "沙尘 RGB（红外合成）",
  varLabelDustcf: "DEBRA 沙尘置信度",
  varLabelZhouye: "ZHOUYE（昼夜）沙尘置信度",
  varLabelTruecolor: "真彩色（白天可见光，夜间红外云图）",
  varLabelGust: "阵风",
  varLabelTcdc: "总云量",
  varLabelCape: "对流有效位能",
  varLabelCin: "对流抑制",
  varLabelVis: "能见度",
  varLabelDpt2m: "2 米露点",
  varLabelAptmp2m: "2 米体感温度",
  varLabelLcdc: "低云量",
  varLabelMcdc: "中云量",
  varLabelHcdc: "高云量",
  varLabelPwat: "大气可降水量",
  varLabelHpbl: "行星边界层高度",
  varLabelPtype: "降水类型",
  varLabelTmpsfc: "海表温度（陆地为地表温度）",
  varLabelIcec: "海冰密集度",
  varLabelIcetk: "海冰厚度",
  varLabelWave: "海浪（有效波高与波向）",
  varLabelHtsgw: "有效波高",
  varLabelPerpw: "主波周期",
  varLabelDirpw: "主波向",
  varLabelWindwave: "风浪（有效波高与波向）",
  varLabelSwell: "涌浪（有效波高与波向，第一分量）",
  varLabelWvhgt: "风浪有效波高",
  varLabelWvper: "风浪平均周期",
  varLabelWvdir: "风浪波向",
  varLabelSwhgt: "涌浪有效波高（第一分量）",
  varLabelSwper: "涌浪平均周期（第一分量）",
  varLabelSwdir: "涌浪波向（第一分量）",
  varLabelAod: "550 nm 气溶胶光学厚度",
  varLabelAoddust: "沙尘光学厚度",
  varLabelAodsalt: "海盐光学厚度",
  varLabelAodsulf: "硫酸盐光学厚度",
  varLabelAodorg: "有机碳光学厚度",
  varLabelAodbc: "黑碳光学厚度",
  varLabelPm25: "地面 PM2.5 浓度",
  varLabelPm10: "地面 PM10 浓度",
  varLabelPm10dust: "地面沙尘 PM10 浓度",
  varLabelDustsfc: "地面沙尘浓度",
  varLabelTsoil1: "土壤温度，第1层",
  varLabelTsoil2: "土壤温度，第2层",
  varLabelTsoil3: "土壤温度，第3层",
  varLabelTsoil4: "土壤温度，第4层",
  varLabelSoilw1: "土壤湿度，第1层",
  varLabelSoilw2: "土壤湿度，第2层",
  varLabelSoilw3: "土壤湿度，第3层",
  varLabelSoilw4: "土壤湿度，第4层",
  varLabelPrmsl: "海平面气压",
  varLabelHeightAtLevel: "{level} 百帕位势高度",
  varLabelTempAtLevel: "{level} 百帕气温",
  varLabelRhAtLevel: "{level} 百帕相对湿度",
  varLabelSpfhAtLevel: "{level} 百帕比湿",
  varLabelWindAtLevel: "{level} 百帕风",
  varLabelQfluxAtLevel: "{level} 百帕水汽通量",
  varLabelVvelAtLevel: "{level} 百帕垂直速度",
  varLabelThetaeAtLevel: "{level} 百帕假相当位温",
  varLabelCatAtLevel: "{level} 百帕晴空湍流（EDR）",
  legendSubtropicalHigh: "588 线",
  webglUnavailable: "此浏览器未提供 WebGL2 上下文",
  pointerRequestFailed: "直播指针请求返回 HTTP {status}",
  manifestRequestFailed: "清单请求返回 HTTP {status}",
  bundleRequestFailed: "数据包请求返回 HTTP {status}",
  bundleTooLong: "数据包超出清单声明的长度",
  bundleLengthMismatch: "数据包长度与清单不一致",
  bundleChecksumMismatch: "数据包校验和不一致",
  bundleRunMismatch: "数据包运行周期与清单不一致",
  bundleMissingVariable: "数据包缺少变量 {id}",
  manifestMissingBundle: "清单缺少变量 {id} 的数据包",
  mosaicNoMembers: "拼图中没有任何卫星数据可用",

  probeAria: "点位数据序列",
  probeHint: "播放或拖动时间轴补全序列",
  probeComplete: "序列已完整",
  probeOutside: "该点在本数据集网格之外",
  probeNoData: "此帧无数据",
  probeAwaiting: "等待该帧解码",
  probeModelElevationLabel: "模式",
  probeDemLabel: "DEM",
  probeCloseAria: "关闭点位数据",
  cardCloseAria: "关闭卡片",

  centerHigh: "高",
  centerLow: "低",

  showcaseLink: "历史个例",
  showcaseBack: "← 全部个例",
  showcaseHome: "实时预报",
  showcaseTitle: "历史个例",
  showcaseHeading: "天气过程回放",
  showcaseArchive: "归档",
  showcaseIntro: "每个个例都是一段历史天气的切片——历史预报,或实况观测:同一套编码管线,裁切到事件所在的区域和时段。",
  showcaseMetaDescription: "历史天气过程回放:台风、暴雨、热浪等个例的裁切数据集,预报与雷达实况",
  showcaseLoading: "正在读取个例目录",
  showcaseEmpty: "暂无历史个例",
  showcaseLoadFailed: "个例目录加载失败:{message}",
  showcaseCaseMissing: "找不到历史个例 {id}",
  showcaseEventLabel: "过程时间",
  showcaseRunLabel: "起报",
  showcaseSeriesLabel: "起点",
  showcaseRangeLabel: "时效",
  showcaseSpanLabel: "时长",
  showcaseRegionLabel: "区域",
  showcaseGridLabel: "网格",
  showcaseSizeLabel: "数据量",
  showcaseVariablesLabel: "变量",
  showcaseHours: "{count} 小时",
  showcaseCaseAria: "打开个例 {title}",
  showcaseListAria: "历史个例列表",

  tcTileTip: "热带气旋",
  varTc: "路径",
  glyphTc: "台",
  tcSheetAria: "热带气旋",
  tcHeading: "热带气旋",
  tcAllSystems: "全部编号系统",
  tcNone: "当前没有活动系统",
  tcUnnamed: "未命名系统",
  tcDisturbances: "扰动与热带低压",
  tcPotential: "潜在系统",
  tcPotentialShow: "显示 {count} 个仅模式系统",
  tcModelOnly: "仅模式",
  tcAgencies: "官方预报",
  tcModels: "模式路径",
  tcMembers: "集合成员",
  tcBest: "最佳路径",
  tcOptionsAria: "台风选项",
  tcHistoryHeading: "历史热带气旋",
  tcHistoryIntro: "存档里的每一个编号风暴：各机构的最佳路径、为它做过的每一次预报，以及每次偏了多远。",
  tcHistorySeasonsAria: "季节",
  tcHistoryBasinsAria: "海域",
  tcHistoryAll: "全部",
  tcHistoryEmpty: "这个季节和海域没有带预报的风暴",
  tcHistoryStormAria: "打开 {name}",
  tcHistorySouthernNote: "南半球的台风季跨年，从 7 月到次年 6 月，按结束的年份命名：{season} 季即 {from} 至 {to}。",
  tcPageTitle: "历史热带气旋",
  tcPageMetaDescription: "一个历史热带气旋：各机构的最佳路径、存档中为它做过的每一次预报，以及每次偏了多远。",
  tcPageLoading: "正在加载风暴",
  tcPageMissing: "存档里没有名为 {id} 的风暴",
  tcPageFailed: "风暴加载失败：{message}",
  tcPageIssue: "时刻",
  tcPageNoForecast: "此时没有预报",
  tcPagePrev: "上一个起报时次",
  tcPageNext: "下一个起报时次",
  tcPageSources: "显示的路径",
  tcPageErrorsHeading: "路径误差（公里）",
  tcPageTruth: "对照的最佳路径",
  tcPageSource: "来源",
  tcPageErrorsMean: "整个风暴的平均",
  tcPageErrorsThis: "地图上这次预报",
  tcPageErrorsNone: "这个风暴还没有预报对照过这条最佳路径",
  tcPageNote: "误差是天气图时次上到最佳路径的距离，只计系统处于热带或副热带气旋阶段的时次；集合按集合平均计。官方预报与同一时次起报的模式并列比较，而这些模式是在官方预报发布之后才跑完的。",
  tcPageId: "ATCF 编号",
  tcPageLife: "生命史",
  tcPagePeak: "最大风速",
  tcPageForecasts: "预报数",
  tcCardSeasons: "季节",
  tcCardStorms: "风暴",
  tcPageDetails: "风暴详情页",
  tcPageSeasonList: "本季全部风暴",
  tcCardBrowse: "按季节浏览",
  tcPageRadii: "风圈",
  tcLegendIntensity: "强度：美国最佳路径，1 分钟平均风",

  soundingTileTip: "无线电探空",
  varSounding: "高空",
  glyphSounding: "探",
  airportTileTip: "机场观测",
  varAirport: "METAR",
  glyphAirport: "机",
  synopTileTip: "地面气象站",
  varSynop: "地面",
  glyphSynop: "站",
  radarTileTip: "单站雷达",
  varRadarSite: "单站",
  glyphRadarSite: "雷",
  radarProductAria: "雷达产品",
  radarLatest: "最新",
  radarCloseAria: "返回拼图",
  radarReflectivity: "反射率",
  radarVelocity: "径向速度",
  stationSounding: "探空",
  stationAirport: "机场",
  stationObserved: "观测",
  stationFreezingLevel: "零度层高度",
  stationPw: "可降水量",
  stationCategory: "飞行类别",
  stationVisibility: "能见度",
  stationQnh: "QNH",
  stationLevels: "层数",
  stationSynop: "气象站",
  stationHumidity: "相对湿度",
  stationPrecipitation: "降水量",
  stationPressure: "本站气压",
  stationSeaLevelPressure: "海平面气压",
  stationSunshine: "日照",
  stationSnowDepth: "积雪深度",
  stationElevation: "海拔",
  stationOpenSounding: "查看探空",
  stationPinHere: "钉在此处",
  fireTileTip: "火点（NASA FIRMS，近 24 小时）",
  varFire: "火点",
  glyphFire: "火",
  fireDetection: "火点",
  fireAcquired: "观测时间",
  fireRadiativePower: "火辐射功率",
  fireBrightness: "亮温",
  fireConfidence: "置信度",
  fireConfidenceLow: "低",
  fireConfidenceNominal: "中",
  fireConfidenceHigh: "高",
  fireOverpass: "过境",
  fireDay: "白天",
  fireNight: "夜间",
  aqTileTip: "空气质量监测站（PM2.5）",
  varAq: "PM2.5",
  glyphAq: "气",
  aqStation: "空气质量",
  aqAgency: "运营机构",
  aqNetwork: "网络",
  aqPreliminary: "初步数据：未经审核，可能修改",
  aqDayRange: "PM2.5，近 24 小时",
  aqNearest: "最近的空气质量监测站，{km} km",
  alertsTileTip: "当前生效的天气预警",
  varAlerts: "预警",
  glyphAlerts: "警",
  alertsCardTitle: "预警",
  alertsInForceNow: "当前生效",
  alertsAsOf: "截至 {time}",
  alertsLevel: "{level} 级",
  alertsUntilCancelled: "直至解除",
  alertsIssued: "{time} 发布",
  alertCategoryRain: "暴雨",
  alertCategoryFlood: "洪水",
  alertCategoryLandslide: "地质灾害",
  alertCategoryWind: "大风",
  alertCategoryThunderstorm: "雷暴",
  alertCategorySnowIce: "冰雪",
  alertCategoryHeat: "高温",
  alertCategoryCold: "低温",
  alertCategoryFog: "雾",
  alertCategoryDust: "沙尘",
  alertCategoryFire: "火险",
  alertCategoryAir: "空气质量",
  alertCategoryCoastal: "沿海",
  alertCategoryMarine: "海上",
  alertCategoryTsunami: "海啸",
  alertCategoryOther: "其他",
  markerPlace: "地点",
  markerEvent: "事件",
  markerSources: "来源",
  caseMarkersAria: "本案例的地点和事件",
  casePartsAria: "本事件的各段",
  riverHeading: "河流流量",
  riverTracksAria: "水文模式运行",
  riverTrackAnalysis: "分析",
  riverTrackForecast: "预报 {cycle}",
  riverKeyAria: "流量与常态流量之比",
  riverRatio2: "低于常态 2 倍",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "按流量着色，色标与图层图例相同",
  riverExtents: "淹没范围",
  riverGaugeHint: "圆圈是水文站：点击查看流量过程线。",
  riverObserved: "实测",
  riverModelled: "模式",
  riverPeaks: "报告的洪峰",
  riverGaugeLoading: "加载中…",
  riverGaugeUnavailable: "无法获取",

  soundingObserved: "实测",
  soundingModel: "模式",
  soundingNoModel: "12 小时内无模式数据",
  soundingLoading: "正在读取探空…",
  soundingUnavailable: "探空不可用",
  soundingExpand: "完整图表",
  soundingClose: "关闭",
  soundingSheetHeading: "探空曲线",
  soundingSheetAria: "探空曲线图",

  // The comparison page (compare.html).
  compareLink: "对比",
  compareTitle: "预报对比",
  compareHeading: "模式对比",
  compareEyebrow: "单点",
  compareIntro:
    "同一地点、同一时间轴上的全部实时预报模式：各家起报对未来数小时至数日的预报，并列于最近机场的实况报文之旁。",
  compareMetaDescription:
    "逐小时对比 GFS、ECMWF、AIFS、IFS HRES 与 HRRR 在同一地点的预报，并与最近机场的 METAR 报文对照。",
  compareLatitude: "纬度",
  compareLongitude: "经度",
  compareLocate: "使用我的位置",
  compareLocateFailed: "无法获取位置",
  compareOnMap: "在地图上查看",
  compareSpan5: "5 天",
  compareSpan15: "15 天",
  compareFieldsAria: "对比的变量",
  compareModelsAria: "模式对比区块",
  compareLoading: "正在读取 {model}…",
  compareModelFailed: "{model}：{message}",
  compareOffGrid: "在该模式网格之外",
  compareNoModels: "没有模式覆盖该点",
  compareHide: "隐藏",
  compareShow: "显示",
  comparePin: "置顶",
  compareHidden: "已隐藏的模式",
  compareRun: "起报",
  compareObservationsFrom: "{icao} 的报文",
  compareNoAirport: "40 公里内无机场",
  compareHours: "时刻",
  compareNow: "现在",
  compareCells: "每个数值取自该模式自身网格中距该点最近的格点，不做插值；时间按你所在时区显示。",
  metricsMetaDescription: "Xue 每个预报批次何时上线的实测记录，来自发布工作流：相对起报时刻的延迟、缺失的批次，以及 ERCOT 日前市场截止时已上线的批次。",
  metricsHeading: "批次到达",
  metricsEyebrow: "实测",
  metricsIntro: "每个预报批次在本站上线的时间，取自发布工作流自身的记录：写入实时指针的时刻，以及它距模式起报时刻多久。",
  metricsNotSla: "以下为实测数据，并非服务承诺：Xue 不对可用性作任何保证。",
  metricsGenerated: "生成于 {time}，最近 {days} 天",
  metricsLoading: "正在读取统计…",
  metricsEmpty: "暂无统计。统计每六小时由发布工作流生成一次，请在下次生成后再来查看。",
  metricsFailed: "统计读取失败:{message}",
  metricsSourcesHeading: "按数据源",
  metricsLatencyNote: "延迟从起报时刻算到批次上线的时刻，因此包含模式自身的生产时间。所有时间均为 UTC。",
  metricsTimelineNote: "每条图带覆盖整个统计窗口：每个已上线的批次一根竖条，位置为起报时刻，高度为延迟（以该数据源自身的最长延迟为满格）；基线下方的标记表示从未到达的批次。",
  metricsTypicalNote: "* 上游典型可用时间：经验值，表示模式自身数据通常在起报后多久齐全，并非实测。没有经验值的留空。",
  metricsTimelineAria: "{model} 在统计窗口内的到达情况",
  metricsCadence: "每 {hours} 小时",
  metricsLatest: "最新批次",
  metricsLanded: "上线时间",
  metricsLatency: "延迟",
  metricsMedian: "中位数",
  metricsMax: "最大",
  metricsTypical: "上游典型",
  metricsCycles: "已到达批次",
  metricsMissing: "缺失",
  metricsMissingList: "缺失的批次",
  metricsRuns: "工作流运行",
  metricsOutcomeLanded: "已上线",
  metricsOutcomeSkipped: "已跳过",
  metricsOutcomeDryRun: "演练",
  metricsOutcomeFailed: "失败",
  metricsBacklog: "还有 {count} 次工作流运行未读取，下次生成时补读。",
  metricsDeadlinesHeading: "截止时刻",
  metricsDeadlineIntro: "每个当地日期，截止时刻已上线的最新批次，以及当时距其起报时刻的时长。",
  metricsSource: "数据源",
  metricsCommonest: "通常",
  metricsNoneLive: "无",
  glyphAurora: "A",
  varAurora: "概率",
  varDis06: "流量",
  varDisrp: "重现期",
  varUpstream: "集水",
  fieldGroupSpace: "空间天气",
  fieldGroupFire: "火险",
  modelGroupForecast: "模式预报",
  modelGroupRadar: "雷达",
  varLabelAurora: "极光可见概率",
  varLabelDis06: "河流流量（6 小时平均）",
  varLabelDisrp: "重现期等级",
  varLabelUpstream: "上游集水面积",
  creditsAurora: "空间天气：极光可见概率，NOAA SWPC OVATION 模式",
  creditsEfas: "河流流量：Copernicus EMS EFAS v5，欧洲 1′；仅限案例",
  creditsEra5: "再分析：Copernicus C3S ERA5（ECMWF），全球 0.25°，逐小时，CC-BY-4.0；仅限案例",
  creditsCams: "气溶胶分析：Copernicus CAMS（ECMWF），全球 0.4°，每 3 小时，CC-BY-4.0；仅限案例",
};
